---
en:
  news_items:
    attachment: Attachment
    categories:
      findings: Findings
      landowner: Landowner
      news: News
      other: Other
      project: Project
      report: Report
      user_manual: User manual
    community_access: Users can see community posts
    community_warning: Community posts will be visible for all portal users
    create_post: Create post
    edit_post: Edit post
    filter_all: All posts
    filter_category: Filter by category
    filter_community: Community posts
    filter_internal: Internal posts
    filter_power_plant: Filter by power plant
    flash_delete_error: Could not be deleted
    hydro_power_news: Hydro power news
    image_positions:
      left: Left
      right: Right
      top: Top
    landowner_access_info: Landowners in this company and its subsidiaries will be able to see this post
    latest_posts: Latest posts
    markdown_supported: Markdown supported
    model_name: News item
    portfolio_warning: Subsidiaries of this company will be able to read this post
    publish: Create post
    save: Save post
    search_placeholder: Search by title, content, or author...
    submit_draft: Save as draft
    subsidiaries_warning: This post will be visible to all portfolio and editor users in subsidiaries of the selected companies (landowner access requires separate checkbox)
    unpublished_draft: You have unpublished drafts
